import "./Projects.css";

import {
  openSourceProject,
  projects,
  projectsHeader,
} from "../../portfolio.js";

import { Fade } from "react-reveal";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import OpenSourceCard from "../../components/opensourceCard/OpenSourceCard";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import ProjectsImg from "./ProjectsImg";
import React from "react";
import { style } from "glamor";

function Projects(props) {
  const theme = props.theme;

  const styles = style({
    backgroundColor: `${theme.accentBright}`,
    ":hover": {
      boxShadow: `0 5px 15px ${theme.accentBright}`,
    },
  });

  return (
    <div className="projects-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="projects-heading-div">
            <div className="projects-heading-img-div">
              <ProjectsImg theme={theme} />
            </div>
            <div className="projects-heading-text-div">
              <h1
                className="projects-heading-text"
                style={{ color: theme.text }}
              >
                {projectsHeader.title}
              </h1>
              <p
                className="projects-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {projectsHeader["description"]}
              </p>
            </div>
          </div>
        </Fade>
      </div>

      <div style={{ margin: "40px 0" }}>
        <h2
          style={{
            color: theme.text,
            marginBottom: "20px",
            fontFamily: "Google Sans Medium",
          }}
        >
          Featured Open Source
        </h2>
        {openSourceProject.data.map((proj) => (
          <OpenSourceCard key={proj.id} project={proj} theme={theme} />
        ))}
      </div>

      <div className="repo-cards-div-main">
        {projects.data.map((repo) => {
          return <ProjectCard repo={repo} theme={theme} />;
        })}
      </div>
      <br />
      <br />
      <br />
      <a
        {...styles}
        className="general-btn"
        href="https://github.com/kingmaker9841"
      >
        More Projects (Github)
      </a>
      <br />
      <br />
      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Projects;
